/**
 * Custom Animations Handler
 *
 * Handles custom animation logic for reusable animation classes.
 * - animate--split-in: Splits text into words and wraps each word in a span
 * - Words animate with stagger effect (fade in + up + blur)
 * - Works with scroll-trigger system
 */

(function () {
  'use strict';

  // Check for reduced motion preference
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  /**
   * Split element text into words and wrap each word in a span
   */
  function splitIntoWords(element) {
    if (!element || element.dataset.wordsSplit) return;

    const text = element.textContent.trim();
    const words = text.split(/\s+/);

    // Clear existing content
    element.textContent = '';

    // Wrap each word in a span
    words.forEach((word, index) => {
      const span = document.createElement('span');
      span.className = 'animate--split-in__word';
      span.textContent = word;
      span.style.transitionDelay = `${index * 0.05}s`;
      element.appendChild(span);

      // Add space after word (except last)
      if (index < words.length - 1) {
        element.appendChild(document.createTextNode(' '));
      }
    });

    // Mark as processed
    element.dataset.wordsSplit = 'true';
  }

  /**
   * Initialize split-in animations for all elements with animate--split-in class
   */
  function initializeSplitInAnimations(rootEl = document) {
    const elements = Array.from(rootEl.querySelectorAll('.animate--split-in'));
    if (elements.length === 0) return;

    // Split words immediately on initialization (before setting up observer)
    elements.forEach((element) => {
      splitIntoWords(element);
    });

    // The scroll-trigger system (animations.js) will handle removing scroll-trigger--offscreen
    // No need to set up our own observer - elements should already have scroll-trigger classes
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeSplitInAnimations();
    });
  } else {
    initializeSplitInAnimations();
  }

  // Handle Shopify theme editor
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      initializeSplitInAnimations(event.target);
    });
    document.addEventListener('shopify:section:reorder', () => {
      initializeSplitInAnimations(document);
    });
  }
})();
